import {
  House,
  Heart,
  ForkKnife,
  Wine,
  Users,
  AddressBook,
  Storefront,
  FolderOpen,
  Images,
  Clock,
  ShieldCheck,
  MapPin,
  Gear,
  CalendarPlus,
  ListChecks,
  Receipt,
} from "@phosphor-icons/react";

export const CLIENT_NAV = [
  { section: "Dashboard" },
  {
    to: "/",
    label: "Dashboard",
    icon: House,
    end: true,
    testid: "nav-dashboard",
  },
  { section: "On the day" },
  {
    to: "/running-order",
    label: "Running Order",
    icon: Clock,
    testid: "nav-running-order",
  },
  {
    to: "/run-sheet",
    label: "Run Sheet",
    icon: ListChecks,
    testid: "nav-run-sheet",
  },
  { section: "Planning" },
  { to: "/plan", label: "Plan", icon: ListChecks, testid: "nav-plan" },
  { to: "/ceremony", label: "Ceremony", icon: Heart, testid: "nav-ceremony" },
  { to: "/menu", label: "Menu", icon: ForkKnife, testid: "nav-menu" },
  { to: "/drinks", label: "Drinks", icon: Wine, testid: "nav-drinks" },
  { to: "/guests", label: "Guests", icon: Users, testid: "nav-guests" },
  { to: "/forms", label: "Forms", icon: ListChecks, testid: "nav-forms" },
  {
    to: "/floor-plans",
    label: "Floor plans",
    icon: MapPin,
    testid: "nav-floor-plans",
  },
  {
    to: "/suppliers",
    label: "My Suppliers",
    icon: AddressBook,
    testid: "nav-suppliers",
  },
  {
    to: "/mood-board",
    label: "Mood Board",
    icon: Images,
    testid: "nav-moodboard",
  },
  {
    to: "/consent",
    label: "Social Media Consent",
    icon: ShieldCheck,
    testid: "nav-consent",
  },
  {
    to: "/invoices",
    label: "Invoices",
    icon: Receipt,
    testid: "nav-invoices",
  },
  { section: "Venue & reference" },
  {
    to: "/venue",
    label: "Venue & FAQs",
    icon: MapPin,
    testid: "nav-venue",
  },
  {
    to: "/preferred-suppliers",
    label: "Preferred Suppliers",
    icon: Storefront,
    testid: "nav-preferred",
  },
  {
    to: "/venue-styling",
    label: "In-house styling",
    icon: Images,
    testid: "nav-venue-styling",
  },
  {
    to: "/resources",
    label: "Other resources",
    icon: FolderOpen,
    testid: "nav-resources",
  },
  { section: "Account" },
  { to: "/account", label: "Account", icon: Gear, testid: "nav-account" },
];

export const STAFF_NAV = [
  { section: "Operations" },
  {
    to: "/",
    label: "Dashboard",
    icon: House,
    end: true,
    testid: "nav-staff-dashboard",
  },
  {
    to: "/events",
    label: "Events",
    icon: CalendarPlus,
    testid: "nav-staff-events",
  },
  { section: "Venue & reference" },
  {
    to: "/venue",
    label: "Venue & FAQs",
    icon: MapPin,
    testid: "nav-staff-venue",
  },
  { to: "/forms", label: "Forms", icon: ListChecks, testid: "nav-staff-forms" },
  {
    to: "/preferred-suppliers",
    label: "Preferred Suppliers",
    icon: Storefront,
    testid: "nav-staff-preferred",
  },
  { to: "/floor-plans", label: "Floor plans", icon: MapPin, testid: "nav-staff-floor-plans" },
  {
    to: "/venue-styling",
    label: "In-house styling",
    icon: Images,
    testid: "nav-staff-venue-styling",
  },
  {
    to: "/resource-library",
    label: "Other resources",
    icon: FolderOpen,
    testid: "nav-staff-library",
  },
  { section: "Account" },
  { to: "/account", label: "Account", icon: Gear, testid: "nav-staff-account" },
];
